import { OFFICE_IMG, CENTER_BG } from "@/mocks/lawfirm";

export default function Center() {
  return (
    <section id="center" className="relative py-16 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${CENTER_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/90 to-primary-950/80"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="text-white">
            <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-medium text-accent-300 tracking-wide">
              <i className="ri-safe-2-line"></i>
              DEBT RELIEF CENTER
            </p>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold leading-snug">
              법무법인 평율 <span className="text-accent-400">회생·파산센터</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-white/80 leading-relaxed">
              채무로 지친 의뢰인들의 새로운 시작을 돕는 회생·파산 전문 센터.
              개인회생·개인파산·법인회생·파산까지, 광주부장판사·검사출신변호사와
              전문 상담사가 함께 종합적인 해결책을 제시합니다.
            </p>

            <ul className="mt-6 space-y-3 text-sm text-white/85">
              {[
                "개인회생·개인파산·면책 원스톱 상담",
                "법인회생·법인파산·워크아웃 지원",
                "채무조정·신용회복 프로그램 연계",
                "전문 상담사 1:1 맞춤 플랜",
              ].map((t) => (
                <li key={t} className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-lg"></i>
                  <span>{t}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://blog.naver.com/lawpy9990"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-md bg-accent-500 px-7 py-3.5 text-sm font-semibold text-white hover:bg-accent-600 transition-colors"
              >
                <i className="ri-blogger-line text-lg"></i>
                회생파산센터 블로그 바로가기
              </a>
              <a
                href="#contact"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-7 py-3.5 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
              >
                <i className="ri-phone-line text-lg"></i>
                T. 062-227-9960
              </a>
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-white/10">
            <img
              src={OFFICE_IMG}
              alt="법무법인 평율 회생파산센터 전경"
              title="법무법인 평율 회생파산센터"
              className="w-full h-[340px] md:h-[440px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}